module.exports = __webpack_public_path__ + "static/m-weierich-99e23c663a21f67b141e6c1f95ec0ce3.png";